<template>
    <transition name="fade">
        <div class="keyboard-overlay">
            <div class="keyboard" v-if="isVisible">
                <div class="keyboard-row" v-for="(row, index) in keyboardLayout" :key="index">
                    <button class="keyboard-button" v-for="key in row" :key="key"
                            :class="{ 'keyboard-button--large': key === 'space' }"
                            @click="buttonClick(key)">{{ key === 'space' ? '&nbsp;' : key }}
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name:    'KeyboardComponent',
    data:    function () {
        return {
            isVisible:      true,
            keyboardLayout: [
                ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'backspace'],
                ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'ü'],
                ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'ö', 'ä'],
                ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
                ['space']
            ]
        };
    },
    methods: {
        buttonClick(key) {
            if (key === 'space') key = ' ';

            this.$emit('keyPress', key);
        }
    }
}
</script>

<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

.keyboard-overlay{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto !important;
    background-color: #F8F5F2;
    z-index: 999;
}

.keyboard {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    margin: 0 auto;
    width: 100%;
    max-width: 1000px;
    z-index: 99;
    padding: calc(1rem + 1vw);

    @media (max-width: 1138px) {
        max-width: 800px;
    }
}

.keyboard-row {
    display: flex;
    justify-content: center;
    margin-bottom: 1%;
    width: 100%;
}

.keyboard-button {

    flex-grow: 1;
    flex-shrink: 1;
    margin: 0 1%;
    padding: 0.2vw;
    background-color: white;
    border: none;
    border-radius: 5%;
    color: rgb(62, 68, 98);
    font-size: 14px;
    transition: background-color 0.3s ease;
    box-shadow: 1px 1px 2px 2px #ccc;
    &:hover {
        box-shadow: inset 1px 1px 2px 2px rgba(204, 204, 204, 1);
    }

    &--large {
        width: 47%;
    }
}
</style>
